import WebVTTParser from './webvtt-parser';
import { secondsToFormattedLabel } from '../../utils/date';

const MAX_CAPTION_TRANSCRIBE_TIME_SEC = 2 * 60 * 60; //2 hrs

var module = angular.module('caption-editor');

module.directive('captionTranscribeProgress', function () {
  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      captionMeta: '=',
    },
    template: `
    <div class="well" style="margin:30px 0">
      <uib-progressbar value="vm.progress()" max="100" style="margin:15px 0">
        {{vm.progress()}}% Processed
      </uib-progressbar>
      <table style="width:100%;font-size:8pt;">
        <tr>
          <td width="5%">Starting</td>
          <td width="25%">Processing Audio</td>
          <td width="40%">Transcribing</td>
          <td width="20%">Processing Transcription</td>
          <td width="10%">Complete</td>
        </tr>
      </table>
    </div>
    `,
    controllerAs: 'vm',
    controller: function ($scope) {
      'ngInject';

      this.progress = function () {
        if (!$scope.captionMeta) return 0;
        const { status, updated_at } = $scope.captionMeta;
        if (status == 'failed') return 0;
        if (status == 'requested') return 5;
        if (status == 'requesting_audio') return 10;
        if (status == 'processing_audio') {
          // estimate percent of way through the extraction based on start date
          var totalDuration = $scope.broadcast.recording_duration_seconds || 60 * 30;
          var processingTime = moment().diff(updated_at, 'seconds') || 0;
          return 10 + Math.round(20 * Math.min(1, processingTime / totalDuration));
        }
        if (status == 'transcribing') {
          // estimate percent of way through the transcribe process based on start date
          var totalDuration = $scope.broadcast.recording_duration_seconds || 60 * 30;
          var processingTime = Math.min(
            moment().diff(updated_at, 'seconds') || 0,
            MAX_CAPTION_TRANSCRIBE_TIME_SEC
          );
          return 30 + Math.round(50 * Math.min(1, processingTime / totalDuration));
        }
        if (status == 'processing_transcription') return 90;
        if (status == 'completed') return 100;
        return 100;
      };
    },
  };
});

var PARTIAL_TEMPLATE_WEBVTT_UPLOAD = `
  <div class="row">
    <div class="col-sm-6">
      <div class="caption-upload-cell" style="margin:15px auto 0; max-width:300px">
        <upload-slot ng-model="vm.captionFile"
                    ng-change="vm.uploadCaption(vm.captionFile)"
                    slot-name="'caption'"
                    allow-image="false"
                    allow-video="false"
                    hide-stock-browse="true"
                    hide-recent-browse="true"
                    compact="true"></upload-slot>
      </div>
    </div>
    <div class="col-sm-6">
      <p ng-hide="vm.uploadWebVTT" class="help-block" style="margin:45px 15px 0">
        WebVTT caption files generated from other services and tools may be uploaded to BoxCast.
        <a href="https://support.boxcast.com/en/articles/4235125" target="_blank">Learn More</a>
      </p>
      <div ng-show="vm.uploadWebVTT && vm.uploadWebVTT.errors.length">
        <h4>Error Processing WebVTT File</h4>
        <ul class="text-left text-danger">
          <li ng-repeat="e in vm.uploadWebVTT.errors">{{e.message}} (line {{e.line}}, col {{e.col}})</li>
        </ul>
      </div>
      <div ng-show="vm.uploadWebVTT && !vm.uploadWebVTT.errors.length">
        <h4>Review WebVTT Upload</h4>
        <textarea class="form-control" rows="15" style="font-size:8pt;font-family:monospace" readonly>{{vm.uploadWebVTTText}}</textarea>
      </div>
    </div>
  </div>

  <div style="margin-top:15px" ng-if="vm.uploadWebVTT && vm.uploadWebVTT.cues.length && !vm.uploadWebVTT.errors.length">
    <button ng-click="onCreate({upload: vm.uploadWebVTT})" type="button" class="btn btn-lg btn-primary">
      Saved Uploaded Caption File
    </button>
  </div>
`;

module.directive('captionDetails', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      captionMeta: '=',
      linkToEditor: '=',
      onCreate: '&',
      onDownload: '&',
    },
    template: `
    <div>

      <div ng-if="!captionMeta" style="max-width:800px; margin:0 auto;">
        <div ng-if="::($root.account.feature_flags.automated_captioning || $root.account.feature_flags.live_automated_captioning)">
          <h4><strong>Add Captions Automatically</strong></h4>
          <p class="help-block text-center" style="margin:15px 0">
            Click "Generate Captions" to start the automatic transcription and captioning of your broadcast.
            This process will usually take around 1 hour. You will then be able to edit the captions before publishing.
          </p>
          <button ng-click="onCreate()" type="button" class="btn btn-lg btn-primary">
            Generate Captions
          </button>
        </div>

        <div ng-if="::(!$root.account.feature_flags.automated_captioning && !$root.account.feature_flags.live_automated_captioning)">
          <div class="row">
            <div class="col-sm-6">
              <img class="img" src="/img/sample-automated-captions.png" style="max-width:100%">
            </div>
            <div class="col-sm-6 text-left">
              <h4><strong>Add Captions Automatically</strong></h4>
              <p class="help-block" style="margin:15px 0">
                A 1 hour broadcast can take up to 3 hours to manually caption. Save yourself the time and
                automatically caption your recorded broadcasts with the touch of a button.
                <a href="https://support.boxcast.com/en/articles/4235130" target="_blank">Learn More</a>
              </p>
              <upgrade-button></upgrade-button>
            </div>
          </div>
        </div>

        <hr style="width:50%;margin:30px auto">
        <h4 class="text-center"><strong>Add Captions Manually</strong></h4>
        <div>${PARTIAL_TEMPLATE_WEBVTT_UPLOAD}</div>
      </div>

      <div ng-if="captionMeta.status == 'failed'" style="max-width:800px; margin:0 auto;">
        <div class="bg-warning text-warning" style="padding:10px;border:1px solid;margin-bottom:30px;">
          The captioning process failed. Reason: {{captionMeta.failure_reason}}.
        </div>
        <button ng-click="onCreate()" type="button" class="btn btn-lg btn-primary">
          Try Captioning Again
        </button>
      </div>

      <div ng-if="captionMeta && (captionMeta.status != 'completed')" style="max-width:800px; margin:0 auto;">
        <h4 class="text-center"><strong>Generating Captions...</strong></h4>
        <p class="help-block text-center" style="margin:15px 0">
          This process will usually take around 1 hour. You will then be able to edit the captions
          before publishing. Feel free to leave the page and come back later.
        </p>
        <caption-transcribe-progress broadcast="broadcast" caption-meta="captionMeta"></caption-transcribe-progress>
      </div>

      <div ng-if="captionMeta && captionMeta.publish_status == 'publishing'" style="max-width:800px; margin:0 auto;">
        <div class="bg-info text-info" style="padding:10px; border:1px solid;margin-bottom:15px;">
          <i class="fa fa-spin fa-spinner"></i>
          The captions are being published and will be available for viewers within a few minutes.
        </div>
      </div>

      <div ng-if="linkToEditor && captionMeta && captionMeta.status == 'completed'">
        <div ng-if="captionMeta.publish_status == 'unpublished'">
          <h4 class="text-center"><strong>Captions Generated &amp; Ready For Review</strong></h4>
          <p class="help-block text-center" style="margin:15px 0">
            Review &amp; Publish your captions to make them available to viewers.
            <br>
            <small>(Hint: Click the settings icon &amp; "Review Low-Confidence Cues" to edit quickly)</small>
          </p>
          <a ui-sref="caption-editor({broadcastId: broadcast.id})" class="btn btn-lg btn-primary">
            Review and Edit
          </a>
        </div>
        <div ng-if="captionMeta.publish_status != 'unpublished'" class="row">
          <div class="col-xs-6 text-left">
            <a ui-sref="caption-editor({broadcastId: broadcast.id})" class="btn btn-sm btn-default">
              <i class="fa fa-edit"></i>
              Edit Captions
            </a>
            <div class="btn-group" uib-dropdown>
              <button tabindex="-1" type="button" class="btn btn-default btn-sm" uib-dropdown-toggle>
                Download Captions
                <i class="fa fa-caret-down" style="margin-left: 5px;"></i>
              </button>
              <ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="btn-append-to-body">
                <li role="menuitem"><a href="javascript://" ng-click="onDownload({format: 'webvtt'})">WebVTT File (.vtt)</a></li>
                <li role="menuitem"><a href="javascript://" ng-click="onDownload({format: 'text'})">Text File (.txt)</a></li>
              </ul>
            </div>
          </div>
          <div class="col-xs-6">
            <table class="text-left" align="right">
              <tr><th class="font-bold text-bx-accessible-grey">Status:</th><td>&nbsp;</td><td>{{captionMeta.publish_status|unslugify}}</td></tr>
              <tr><th class="font-bold text-bx-accessible-grey">Updated:</th><td>&nbsp;</td><td>{{captionMeta.updated_at|date:'medium'}}</td></tr>
            </table>
          </div>
        </div>
      </div>

    </div>
    `,
    controller: function ($scope, $timeout) {
      'ngInject';

      const parser = new WebVTTParser();

      this.uploadCaption = (result) => {
        if (!result) {
          return;
        }

        var r = new FileReader();
        r.onload = (e) => {
          $timeout(() => {
            this.parseFile(e.target.result);
          }, 100);
        };
        r.oneror = (e) => {
          $timeout(() => {
            this.uploadWebVTT = {
              errors: [{ message: 'Unable to read file.', line: 0, col: 0 }],
            };
          }, 0);
        };
        r.readAsText(result.file);
      };

      this.parseFile = (fileContents) => {
        $timeout(() => {
          // Replace plain & with &amp; (but leave &amp; as-is);
          fileContents = fileContents.replace(/&amp;/g, '&').replace(/&/g, '&amp;');

          this.uploadWebVTT = parser.parse(fileContents);
          this.uploadWebVTTText = this.uploadWebVTT.cues
            .map((c) => {
              return `${secondsToFormattedLabel(c.startTime)} - ${c.text}`;
            })
            .join('\n');
        }, 0);
      };
    },
    controllerAs: 'vm',
  };
});



// WEBPACK FOOTER //
// ./app/pages/caption-editor/directives.js